import React from "react";
import CustomCheckbox from "../common/CustomCheckbox";

const RecipientSelect = ({ userList, handleCheck }) => {
    return (
        <div className="recipients-selection-wrapper">
            {
                userList.map((data, index) =>
                    <CustomCheckbox
                        isChecked={data.isChecked}
                        handleCheck={() => handleCheck(index)}
                        key={`recipient-${index}`}
                        disabled={!data.eligible}
                        label={`${data.patientName.toUpperCase()} (${data.dob})`}
                    />
                )
            }
            
        </div>
    );
}

export default RecipientSelect;